export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const isEmailValid = (email = ''): boolean => {
    return emailRegex.test(email);
};
